export const colors = {
  background50: "#1C1D29",
  background100: "#202230",
  background150: "#2A2B3D",
  background200: "#3A3B4F",
  grey: "#6B6B6B",
  lightGrey: "#BEBEBE",
  white: "#F5F5F5",
  black: "#151515",
  green: "#12E11A",
  blue: "#1297E1",
  red: "#E11E12",
  primary: "#0AFFE2",
  primaryHover: "#89FFF1",
};

// 'Ubuntu', sans-serif
export const fontFamilies = {
  heading: "'Poppins', sans-serif",
  body: "'Poppins', sans-serif",
};

export const modalCloseTimeoutMS = 200;

export const columnSize = "max(18rem, 20vw)";

export const breakpoints = {
  phone: "640px",
  tablet: "960px",
};

const theme = {
  colors,
  fontFamilies,
  modalCloseTimeoutMS,
  columnSize,
  breakpoints,
};

export default theme;
